import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';

import Routes from '~/routes/routes';
import ImageNotFound from '~/assets/svg/page_not_found_background.svg';

const NotFoundScreen = (): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <WrapperNotFound>
      <img src={ImageNotFound} alt={t('common_data_not_found')} />
      <div className="h-100 w-100 d-flex flex-column justify-content-evenly align-items-center">
        <p className="text-uppercase">{t('screen_not_found__text')}</p>
        <Link to={Routes.HOME} className="text-uppercase text-white">
          {t('back.backToHomePage')}
        </Link>
      </div>
    </WrapperNotFound>
  );
};

const WrapperNotFound = styled.div`
  border-radius: 10px;
  background: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & img {
    width: 55%;
    max-width: 550px;
    min-width: 310px;
  }

  & p {
    color: #565872;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 4px;
  }

  & a {
    border-radius: 30px;
    background: #1890ff;
    box-shadow: -15px 15px 20px 0px rgba(0, 0, 0, 0.1);
    width: fit-content;
    padding: 8px 20px;
    transition: all 0.2s linear;

    &:hover {
      opacity: 0.8;
      -ms-transform: scale(0.96); /* IE 9 */
      -webkit-transform: scale(0.96); /* Safari 3-8 */
      transform: scale(0.9);
    }
  }
`;

export default NotFoundScreen;
